import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { VOLUMES, VOLUME_INCLUDES } from '../data/content';
export function VolumesSection() {
  return <section id="volumes" className="border-y border-ink-700/60 bg-ink-900 py-10 sm:py-12" style={{
    paddingTop: "0px",
    paddingBottom: "7px"
  }} data-id="element-222" data-mp="cp0yyc53h08e">
      <div className="mx-auto max-w-content px-5" data-id="element-223" data-mp="7q7jwfa5t164">
        <SectionHeading eyebrow="📚 WHAT YOU GET" title="The 6" highlight="Volumes" data-id="element-224" data-mp="3g4pzd22fjizr" />

        <div className="mt-6 grid gap-3 lg:grid-cols-2" data-id="element-225" data-mp="3c3wc8awta87x">
          {VOLUMES.map(volume => <article key={volume.number} className="flex h-full flex-col rounded-2xl border border-ink-700 bg-ink-850 p-5 transition-colors duration-150 ease-out hover:border-lime-700/60" style={{
          paddingTop: "15px",
          paddingBottom: "6px"
        }} data-id="element-226" data-mp="3c1tbavu4euof">
              <div className="flex items-center gap-2" data-id="element-227" data-mp="2xdophizru31f">
                <span className="text-lg" aria-hidden="true" data-id="element-228" data-mp="2xcdp7t5jbdf2">
                  {volume.emoji}
                </span>
                <span className="rounded-full bg-lime-600/15 px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-[0.15em] text-lime-400" data-id="element-229" data-mp="29fs1a7et3v68">
                  {volume.number}
                </span>
              </div>

              <h3 className="mt-2 text-base font-extrabold uppercase leading-tight text-white sm:text-lg" data-id="element-230" data-mp="2j6czvuuhczp5">
                {volume.title}
              </h3>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-white/40" data-id="element-231" data-mp="2o67tw79jy5ef">
                {volume.zones}
              </p>
              <p className="mt-2 text-sm leading-snug text-white/65" data-id="element-232" data-mp="1vgsihgdz6ahz">{volume.body}</p>

              <ul className="mt-3 space-y-1.5 border-t border-ink-700 pt-3" data-id="element-233" data-mp="20ekg8r1awqu3">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2 text-sm text-white/80" style={{
              fontSize: "12px"
            }} data-id="element-234" data-mp="24hgs7ywc5op2">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-lime-400" aria-hidden="true" data-id="element-235" data-mp="3btpjbw5cgre8" />
                    {bullet}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-4 rounded-2xl border border-lime-700/40 bg-ink-850 p-5 text-center" data-id="element-236" data-mp="1gsxb068pwfcx">
          <h3 className="text-xs font-extrabold uppercase tracking-[0.18em] text-lime-400" data-id="element-237" data-mp="1btu3mf59lx1s">
            Every volume includes
          </h3>
          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-6 gap-y-1.5" data-id="element-238" data-mp="1krwfjpqjea3u">
            {VOLUME_INCLUDES.map(item => <li key={item} className="inline-flex items-center gap-2 text-sm font-semibold text-white/80" data-id="element-239" data-mp="x3mwgvkpk0ge">
                <CheckIcon className="h-4 w-4 shrink-0 text-lime-400" aria-hidden="true" data-id="element-240" data-mp="t2t8y3b6gno1" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}